import type { HeroGender } from '@/api/channel/type'
import type { ADType } from '@/types/common'
import { ChannelCategories, ChannelCategoryMap } from 'web/src/utils/consts.tsx'

export const ContentTypes = ChannelCategories.map(type => type.code)

export const ContentTypesOptions = ContentTypes.map(type => {
  return {
    label: ChannelCategoryMap[type]?.kor ?? '',
    value: type,
  }
})

export const Genders = ['MALE', 'FEMALE', 'ALL'] as HeroGender[]

export const GenderOptions = [
  {
    label: '남성',
    value: 'MALE',
  },
  {
    label: '여성',
    value: 'FEMALE',
  },
  {
    label: '모두',
    value: 'ALL',
  },
] as {
  label: string
  value: HeroGender
}[]

export const Generations = [10, 20, 30, 40, 50, 60] as const

export const GenerationOptions = Generations.map(generation => {
  return {
    label: generation !== 60 ? `${generation}대` : '60대 이상',
    value: generation.toString(),
  }
})

export const AdTypeOptions: Array<{
  label: string
  value: Exclude<ADType, null> | ''
}> = [
  {
    label: '유료광고 미포함',
    value: '',
  },
  {
    label: '기획 PPL',
    value: 'PPL',
  },
  { label: '브랜디드', value: 'BRANDED' },
]
